import { Routes } from "@angular/router";
import { FormComponent } from "@progress/kendo-angular-inputs";

export const routes: Routes = [
  {
    path: ':sessionId',
    component: FormComponent
  },
  {
    path: '**',
    component: FormComponent
  }
];
